// ATRIBUCIÓN DE ANUNCIOS (22-oct-2026). Carga en TODAS las páginas (layout/theme.liquid).
// El carrito-copia que crea cart-payment-modal.js (cartCreate por Storefront API) nace sin la
// visita: el pedido llegaba a Shopify sin página de entrada, sin referrer y sin gclid, y Google Ads
// veía 0 compras (#21143 entró por /collections/creatina?gclid=… y quedó con landing «/»).
// Aquí se guarda el clic al entrar. Regla «gana el último clic de anuncio»: una llegada con un
// identificador de clic (gclid, gbraid, wbraid o fbclid) NUEVO reemplaza TODO lo guardado (todos los
// campos juntos, para no mezclar una campaña de Google con un fbclid de Meta). Una visita con solo
// utm/meta_* llena lo guardado si estaba vacío, pero no pisa un clic de anuncio. Sin parámetros no
// cambia nada. Dura 90 días. El modal la pide con
// window.ffAtribucion() y la manda como atributos del carrito con «_» delante, que el checkout no
// le muestra al cliente. Si el almacenamiento está bloqueado, no falla: usa una cookie propia.
(function(){
  var CLAVE='ff_atrib', DIAS=90;
  var PARAMS=['gclid','gbraid','wbraid','fbclid','utm_source','utm_medium','utm_campaign','utm_term','utm_content','meta_campaign_id','meta_adset_id','meta_ad_id','meta_placement'];
  var CLICS=['gclid','gbraid','wbraid','fbclid'];
  var ATTR={gclid:'_gclid',gbraid:'_gbraid',wbraid:'_wbraid',fbclid:'_fbclid',utm_source:'_utm_source',utm_medium:'_utm_medium',utm_campaign:'_utm_campaign',utm_term:'_utm_term',utm_content:'_utm_content',meta_campaign_id:'_meta_campaign_id',meta_adset_id:'_meta_adset_id',meta_ad_id:'_meta_ad_id',meta_placement:'_meta_placement',landing:'_landing',referrer:'_referrer',fecha:'_clic_fecha'};
  function cookie(n){ try{ var m=document.cookie.match(new RegExp('(?:^|; )'+n+'=([^;]*)')); return m ? decodeURIComponent(m[1]) : ''; }catch(e){ return ''; } }
  function leer(){
    var raw=null;
    try{ raw=localStorage.getItem(CLAVE); }catch(e){}
    if(!raw) raw=cookie(CLAVE);
    try{ var o=raw && JSON.parse(raw); if(o && o.t && Date.now()-o.t < DIAS*864e5) return o; }catch(e){}
    return null;
  }
  function guardar(o){
    var s=JSON.stringify(o);
    try{ localStorage.setItem(CLAVE,s); return; }catch(e){}
    try{ document.cookie=CLAVE+'='+encodeURIComponent(s)+'; path=/; max-age='+(DIAS*86400)+'; SameSite=Lax; Secure'; }catch(e){}
  }
  try{
    var u=new URLSearchParams(location.search), nuevo={}, hay=false;
    PARAMS.forEach(function(k){ var v=u.get(k); if(v){ nuevo[k]=v; hay=true; } });
    if(hay){
      var prev=leer();
      var clicNuevo=CLICS.some(function(k){ return nuevo[k] && (!prev || prev[k]!==nuevo[k]); });
      if(!prev || clicNuevo){
        var ref=''; try{ var r=document.referrer ? new URL(document.referrer) : null; if(r && r.hostname.replace(/^www\./,'')!==location.hostname.replace(/^www\./,'')) ref=r.href; }catch(e){}
        nuevo.landing=location.pathname+location.search; nuevo.referrer=ref; nuevo.fecha=new Date().toISOString(); nuevo.t=Date.now();
        guardar(nuevo);
      }
    }
  }catch(e){}
  // Lista [{key,value}] solo con lo que tenga valor. Respaldo del gclid (solo si no hay ningún identificador de clic guardado, para no mezclar Google con Meta): la cookie _gcl_aw de Google
  // («GCL.<fecha>.<gclid>»). Tope de 250 caracteres por valor (límite de los atributos de Shopify).
  window.ffAtribucion=function(){
    var o=leer()||{}, out=[];
    if(!o.gclid && !o.gbraid && !o.wbraid && !o.fbclid){ var g=cookie('_gcl_aw').split('.').slice(2).join('.'); if(g) o.gclid=g; }
    Object.keys(ATTR).forEach(function(k){ if(o[k]) out.push({key:ATTR[k], value:String(o[k]).slice(0,250)}); });
    return out;
  };
})();
